import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";
import { mapKeys } from "lodash";

// First, create the thunk
export const pendingUserRequest = createAsyncThunk("pendingUserList", async ({data,start,limit}) => {
  const response = await Admin.post(`listPendingDetails/${start}/${limit}`,data);
  return response.data.data
});

// Move to Pending User
export const moveUserRequest = createAsyncThunk(
  'moveUser',
  async ({ data }) => {
    await Admin.post('updateUserStatus', data);
    return data;
  }
);

// Delete User
export const deleteUserRequest = createAsyncThunk(
  'deleteUser',
  async ({ data }) => {
    console.log(data,"deleteUserRequest")
    await Admin.delete(`admin/deleteAccount/${data?.id}`);
    return data;
  }
);


// Then, handle actions in your reducers:
const pendingUserSlice = createSlice({
  name: "pendingUser",
  initialState: { pendingUser: [], totalList: '', message: "", loading: false },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer

  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [pendingUserRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, pendingUser: { ...mapKeys(action.payload.users, "_id") }, totalList: action.payload.totalUsers, message: action.payload.message, loading: false };
    },
    [pendingUserRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [pendingUserRequest.rejected]: (state, action) => {
      return {
        ...state,
        pendingUser: action.payload,
        message: "no data",
        loading: false,
      };
    },
    [moveUserRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [moveUserRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
      };
    },
    [moveUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        message: action.payload.message,
        loading: false,
      };
    },
    [deleteUserRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [deleteUserRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
      };
    },
    [deleteUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        message: action.payload.message,
        loading: false,
      };
    },
  },
});

export default pendingUserSlice.reducer;